import { WooChevronRight, WooEnvelope, WooSmartphone } from '@nosinovacao/fe-icons';
import { ActionCard, Captcha, GenericLoader, If, useI18n } from '@nosinovacao/nosid-mfe-common';
import type { ContactSelectionProps } from './props';

export function ContactSelectionWooDark({
  translations,
  phoneAlias,
  emailAlias,
  onContactSelected,
  isSending,
  captchaChallenge,
  onCaptchaChange,
}: Readonly<ContactSelectionProps>) {
  const { t } = useI18n();

  const trailingIcon = isSending ? (
    <GenericLoader className="size-5 animate-spin border-woo-green-100" />
  ) : (
    <WooChevronRight width={20} height={20} />
  );

  return (
    <div className="flex flex-col gap-4">
      <div className="grid gap-2">
        <If condition={!!phoneAlias}>
          <ActionCard
            data-tid="button-contact-phone"
            skin="woo-dark"
            variant="quick-link"
            preTitle={t(translations.phone)}
            subTitle={<></>}
            title={phoneAlias}
            leadingIcon={<WooSmartphone />}
            icon={trailingIcon}
            className="w-full border-solid border-nos-neutral-800 bg-nos-neutral-900"
            disabled={isSending}
            onClick={() => onContactSelected('Sms', phoneAlias ?? '')}
          />
        </If>
        <If condition={!!emailAlias}>
          <ActionCard
            data-tid="button-contact-email"
            skin="woo-dark"
            variant="quick-link"
            preTitle={t(translations.email)}
            subTitle={<></>}
            title={emailAlias}
            leadingIcon={<WooEnvelope />}
            icon={trailingIcon}
            className="w-full border-solid border-nos-neutral-800 bg-nos-neutral-900"
            disabled={isSending}
            onClick={() => onContactSelected('Email', emailAlias ?? '')}
          />
        </If>
        <If condition={captchaChallenge}>
          <Captcha onChange={onCaptchaChange} />
        </If>
      </div>
    </div>
  );
}
